import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsContext } from '../components/settings';
import { allLangs, defaultLang } from './config-lang';

// ----------------------------------------------------------------------

/**
 * Polish is the only language on offer, so this answers 'pl' whatever it is
 * handed — including a stale 'en' from before English was withdrawn.
 */
function resolveLangCode(): string {
  return defaultLang.value;
}

export default function useLocales() {
  const { i18n, t } = useTranslation();

  const translate = useCallback(
    (text: string, options?: Record<string, unknown>) =>
      String(t(text, (options ?? undefined) as never)),
    [t],
  );

  const { onChangeDirectionByLang } = useSettingsContext();

  const langCode = resolveLangCode();

  const currentLang =
    allLangs.find((l) => l.value === langCode) || defaultLang;

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('i18nextLng', newlang);
    }
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLangs,
  };
}
